import { createAction, props } from '@ngrx/store';
import { DiscountRequest } from '@shared/models/discount-request';

export const createDiscountRequest = createAction(
  '[Discount Requests] Create Discount Request',
  props<{ discountRequest: Partial<DiscountRequest> }>(),
);

export const createDiscountRequestSuccess = createAction(
  '[Discount Requests] Create Discount Request Success',
  props<{ discountRequest: DiscountRequest }>(),
);

export const createDiscountRequestFailure = createAction(
  '[Discount Requests] Create Discount Request Failure',
  props<{ error: any }>(),
);
